import React from "react";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import AddIcon from "@mui/icons-material/Add";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Tooltip from "@mui/material/Tooltip";

const cardHeightClass = "h-[30px]";

const EventsNotesRow = ({
  dailyEvents = [],
  onOpenNotes,
  boxStyle,
}) => {
  if (!dailyEvents.length) {
    return (
      <div className="border-t border-gray-200" style={boxStyle}>
        <div className="w-full h-full flex items-center justify-center group">
          <Tooltip title="Add note" arrow>
            <button
              type="button"
              onClick={onOpenNotes}
              className={`w-full ${cardHeightClass} bg-white text-xs font-medium text-gray-500 hover:text-violet-600 flex items-center justify-center gap-2 transition-colors`}
            >
              <AddIcon className="opacity-0 group-hover:opacity-100 transition-opacity" style={{ fontSize: "16px" }} />
            </button>
          </Tooltip>
        </div>
      </div>
    );
  }

  return (
    <div className="border-t border-gray-200" style={boxStyle}>
      <div className="w-full h-full flex flex-col space-y-1 overflow-hidden">
        {dailyEvents.map((event, index) => (
          <button
            type="button"
            key={event.id ?? index}
            onClick={onOpenNotes}
            className={`w-full ${cardHeightClass} rounded-lg bg-white border border-violet-100 hover:border-violet-300 hover:bg-violet-50 text-left text-xxs font-semibold text-slate-600 px-3 flex items-center transition-colors`}
            title={event.title || "Untitled note"}
          >
            <div className="flex items-center gap-2 w-full">
              <NoteAltOutlinedIcon style={{ fontSize: "16px", color: "#7c3aed" }} />
              <span className="truncate flex-1 min-w-0">
                {event.title && event.title.trim().length > 0
                  ? event.title
                  : "Untitled note"}
              </span>
              {event.attachments?.length > 0 && (
                <span className="flex items-center gap-0.5 text-violet-500 shrink-0">
                  <AttachFileIcon style={{ fontSize: "13px" }} />
                  {event.attachments.length > 1 && (
                    <span className="text-xxs">{event.attachments.length}</span>
                  )}
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EventsNotesRow;
